import React from "react";
import { Router, Route, IndexRoute, IndexRedirect, withRouter, Redirect } from "react-router";
import App from "./components/App";
import RecommendationRecorder2 from "./recorder/RecommendationRecorder";
import CompliancePortal from "./compliance/CompliancePortal";
import UptakeReport from "./compliance/uptake/UptakeReport";
import SignIn from "./authentication/components/SignIn";
import RegisterUser from "./authentication/components/RegisterUser";
import UserDetailsForm from "./authentication/components/UserDetailsForm";
import ExploreCommunications from "./compliance/monitor/ExploreCommunications";
import DisclosureApp from "./disclosure/App";
import VerifyEmail from "./disclosure/portal/components/VerifyEmail";
import Portal from "./disclosure/portal/components/Portal";
import PortalVerificationCallback from "./disclosure/portal/components/PortalVerificationCallback";
import Disclosures from "./disclosure/components/Disclosures";
import DisclaimersCsvUpload from "./disclosure/components/DisclaimersCsvUpload";
import { requestRecorderAuthenticationStatus } from "./authentication/actions/authenticationRequests";
import { requestDisclosureAuthenticationStatus } from "./authentication/actions/disclosureAuthenticationRequests";
import { requestRegistrationDetails } from "./authentication/actions/registrationRequests";
import { ROLES } from "./authentication/authenticationConstants";

export const COMPLIANCE_ROUTES = [
    "compliance/communications",

];
export const COMPLIANCE_COMMUNICATIONS_ROUTE = "compliance/communications";

const AppRouter = (props) => {
    return (
        <Router history={props.history}>
            <Route path="/" component={App}>
                <IndexRedirect to="recorder"/>

                <Route path="recorder" component={RecommendationRecorder2} onEnter={requireAuthentication}/>

                <Route path="compliance" onEnter={requireAuthentication}>
                    <IndexRoute component={withRouter(CompliancePortal)} />
                    <Route path="communications" component={withRouter(ExploreCommunications)} />
                </Route>

                <Redirect from="disclaimers/*" to="disclaimers"/>
                <Route path="disclaimers" component={DisclaimersCsvUpload} onEnter={requireAuthentication}/>

                <Route path="uptake-report" component={UptakeReport} onEnter={requireAuthentication}/>

                <Route path="sign-in" component={SignIn} onEnter={onSignInEnter}/>

                <Route path="register" component={RegisterUser} />
                <Route path="enter-details" component={UserDetailsForm} />
            </Route>

            <Route path="/verify-email" component={ componentInDisclosureApp(VerifyEmail) } />
            <Route path="/portal" component={ componentInDisclosureApp(Portal) } onEnter={requireAuthentication} />
            <Route path="/portal/verify/:verificationToken" component={ componentInDisclosureApp(PortalVerificationCallback) } />
            <Route path="/recommendations/:recommendationId" component={ componentInDisclosureApp(Disclosures) } />
        </Router>
    );
};

function componentInDisclosureApp(Component) {
     return props => <DisclosureApp {...props}><Component {...props} /></DisclosureApp>
}

function requireAuthentication(nextState, replace, callback) {
    requestRecorderAuthenticationStatus(userInfo => {
        if (userInfo.userId === null) {
            requestDisclosureAuthenticationStatus(status => {
                if (status.emailAddress === null) {
                    replace({
                        pathname: '/sign-in',
                        state: { nextPathname: nextState.location.pathname }
                    });
                } else {
                    safeReplace("/portal", nextState, replace);
                }
                callback();
            });
        } else {
            requestRegistrationDetails((code) => {
                if (code == 404) {
                    replace({
                        pathname: "/enter-details",
                        state: { nextPathname: nextState.location.pathname }
                    });
                    callback();
                } else {
                    goHome(userInfo, nextState, replace, callback);
                }
            });
        }
    });
}

function onSignInEnter(nextState, replace, callback) {
    requestRecorderAuthenticationStatus(userInfo => {
        if (userInfo.userId !== null) {
            goHome(userInfo, nextState, replace, callback);
        } else {
            requestDisclosureAuthenticationStatus(status => {
                if (status.emailAddress !== null) {
                    replace({
                        pathname: '/portal',
                        state: { nextPathname: nextState.location.pathname }
                    });
                }
                callback();
            });
        }
    });
}

function goHome(userInfo, nextState, replace, callback) {
    if (userInfo.topLevelRole === ROLES.COMPLIANCE_OFFICER) {
        const destination = nextState.location.pathname;

        if (!destination.startsWith("/compliance") && !destination.startsWith("/disclaimers")) {
            safeReplace("/compliance", nextState, replace);
        }
    } else {
        safeReplace("/recorder", nextState, replace);
    }
    callback();
}

function safeReplace(pathname, nextState, replace) {
    if (nextState.location.pathname !== pathname) {
        replace(pathname);
    }
}

export default AppRouter;


/** WEBPACK FOOTER **
 ** ./src/main/javascript/AppRouter.js
 **/